import { IconButton, Tooltip } from '@material-ui/core';
import { GridOn } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { AccessRoles } from '../../../..';
import { CustomAutoCompleteField } from '../../../commons/CustomAutoCompleteField';
import { CustomFormikNumberField } from '../../../commons/CustomFormikNumberField';
import { DuoColumnSelector } from '../../../commons/DuoColumnSelector';
import { Groups } from '../Groups';
import { CheckBoxGroupWrapper, GroupWrapper, TextWrapper, Wrapper, } from './GeneralForm.Styles';
export var GeneralForm = function (_a) {
    var groups = _a.groups, queues = _a.queues, contactLists = _a.contactLists, availableCallerIDs = _a.availableCallerIDs, contactFlows = _a.contactFlows, contactList = _a.contactList, formValues = _a.formValues, accessLevel = _a.accessLevel, getOneContactList = _a.getOneContactList, onAddGroup = _a.onAddGroup, onEditGroup = _a.onEditGroup, onDeleteGroup = _a.onDeleteGroup, registerField = _a.registerField, setCampaignMode = _a.setCampaignMode;
    var _b = useState([]), phoneTypes = _b[0], setPhoneTypes = _b[1];
    var _c = useState(true), pTValueStatus = _c[0], setPTValueStatus = _c[1];
    var _d = useState(false), openGroup = _d[0], setOpenGroup = _d[1];
    var _e = useState(''), mode = _e[0], setMode = _e[1];
    var _f = useState([
        {
            label: 'Power',
            value: 'power'
        },
        {
            label: 'Agentless',
            value: 'agentless'
        },
    ]), modeOptions = _f[0], setModeOptions = _f[1];
    useEffect(function () {
        setMode(formValues === null || formValues === void 0 ? void 0 : formValues.callingMode);
    }, [formValues === null || formValues === void 0 ? void 0 : formValues.callingMode]);
    useEffect(function () {
        if ((contactList === null || contactList === void 0 ? void 0 : contactList.id) === formValues.contactList) {
            setPhoneTypes(contactList.PhoneTypes);
        }
        else {
            setPhoneTypes([]);
        }
    }, [contactList]);
    useEffect(function () {
        if (formValues.contactList) {
            getOneContactList(formValues.contactList);
        }
        else {
            setPhoneTypes([]);
        }
        setPTValueStatus(false);
    }, [formValues.contactList]);
    return (React.createElement(Wrapper, null,
        React.createElement(TextWrapper, null,
            React.createElement(GroupWrapper, null,
                React.createElement(CustomAutoCompleteField, { options: groups.map(function (grp) { return ({ label: grp.name, value: grp.id }); }), name: 'group', label: 'Group', placeholder: 'Please Select', fullWidth: true }),
                React.createElement(Tooltip, { title: 'Manage Groups', placement: 'top' },
                    React.createElement(IconButton, { size: 'small', onClick: function () { return setOpenGroup(true); } },
                        React.createElement(GridOn, null)))),
            React.createElement(TextWrapper, null,
                React.createElement(CustomAutoCompleteField, { options: modeOptions.map(function (_a) {
                        var label = _a.label, value = _a.value;
                        return ({
                            label: label,
                            value: value
                        });
                    }) || [], name: 'callingMode', label: 'Calling Mode', placeholder: 'Please Select', onHandleChange: function (value) {
                        setCampaignMode(value);
                    }, fullWidth: true })),
            mode !== 'agentless' ? (React.createElement(React.Fragment, null,
                React.createElement(CustomAutoCompleteField, { options: (queues === null || queues === void 0 ? void 0 : queues.map(function (_a) {
                        var Id = _a.Id, Name = _a.Name;
                        return ({
                            label: Name + " - " + Id,
                            value: Id
                        });
                    })) || [], name: 'queue', label: 'Queue', placeholder: 'Please Select', disabledValues: [], fullWidth: true }))) : null,
            React.createElement(CustomAutoCompleteField, { options: (contactLists === null || contactLists === void 0 ? void 0 : contactLists.map(function (_a) {
                    var id = _a.id, ContactListConfigName = _a.ContactListConfigName;
                    return ({
                        label: "" + ContactListConfigName,
                        value: id
                    });
                })) || [], name: 'contactList', label: 'Contact List', onHandleChange: function (value) {
                    var contactList = value;
                    if (contactList) {
                        getOneContactList(contactList);
                    }
                    else {
                        setPhoneTypes([]);
                    }
                    setPTValueStatus(true);
                }, placeholder: 'Please Select', fullWidth: true }),
            React.createElement(CustomAutoCompleteField, { options: (availableCallerIDs === null || availableCallerIDs === void 0 ? void 0 : availableCallerIDs.map(function (_a) {
                    var PhoneNumber = _a.PhoneNumber;
                    return ({
                        label: PhoneNumber,
                        value: PhoneNumber
                    });
                })) || [], name: 'defaultCallerID', label: 'Default Caller ID', placeholder: 'Please Select', fullWidth: true }),
            React.createElement(CustomFormikNumberField, { name: 'weight', label: 'Campaign Priority', fullWidth: true, min: 1, max: 100 }),
            React.createElement(CustomAutoCompleteField, { options: (contactFlows === null || contactFlows === void 0 ? void 0 : contactFlows.map(function (_a) {
                    var Id = _a.Id, Name = _a.Name;
                    return ({
                        label: Name + " - " + Id,
                        value: Id
                    });
                })) || [], name: 'contactFlowOverride', label: 'Contact Flow Override', placeholder: 'Please Select', fullWidth: true })),
        React.createElement(CheckBoxGroupWrapper, null,
            React.createElement(DuoColumnSelector, { name: 'activePhoneFields', label: 'Active Phone Fields', dependency: phoneTypes, itemOptions: phoneTypes, doValueChange: pTValueStatus })),
        React.createElement(Groups, { open: openGroup, isReadOnly: accessLevel === AccessRoles.READ_ONLY, onClose: function () { return setOpenGroup(false); }, groups: groups, onAddGroup: function (group) {
                onAddGroup(group);
            }, onEditGroup: function (group, id, initialGroup) {
                onEditGroup(group, id, initialGroup);
            }, onDeleteGroup: function (id) { return onDeleteGroup(id); } })));
};
GeneralForm.defaultProps = {
    isSubmitting: false
};
//# sourceMappingURL=GeneralForm.js.map